import "./social-share.scss"
import { FacebookShareButton, TwitterShareButton } from 'react-share'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { AiFillFacebook, AiFillTwitterCircle, AiOutlineLink } from "react-icons/ai"

const GAME_HTML = {
    // FLAPPY_BLOCK: 'https://blockfriday.wpstackable.com/flappy-block.html',
    // MEMORY_BLOCK: 'https://blockfriday.wpstackable.com/memory-block.html',
    // WHACK_A_BLOCK: 'https://blockfriday.wpstackable.com/whack-a-block.html',
    FLAPPY_BLOCK: 'https://wpstackable.com/bfcm-2023/',
    MEMORY_BLOCK: 'https://wpstackable.com/bfcm-2023/',
    WHACK_A_BLOCK: 'https://wpstackable.com/bfcm-2023/',
}

const GAME_NAMES = {
    FLAPPY_BLOCK: 'Flappy Block',
    MEMORY_BLOCK: 'Memory Block',
    WHACK_A_BLOCK: 'Whack-A-Block',
}

const twitterHashtags = [ "StackableBlockFriday", "BlackFriday", "WordPress" ]
const twitterRelated = ["wpstackable"]

const SocialShare = props => {
    const message = ! props.score 
        ? `Let's take a break from all these Black Friday deals, let's play ${ GAME_NAMES[ props.game ] } and win AirPods!\n\n` 
        : `I scored ${ props.score } in ${ GAME_NAMES[ props.game ] }! Let's take a break from all these Black Friday deals.\n\n`

    return (
        <div className="social-share">
            { props.label }
            <FacebookShareButton url={ GAME_HTML[ props.game ] } quote={ message } hashtag="#StackableBlockFriday">
                <AiFillFacebook/>
            </FacebookShareButton>
            <TwitterShareButton url={ GAME_HTML[ props.game ] } title={ message } hashtags={ twitterHashtags } related={ twitterRelated }>
                <AiFillTwitterCircle/>
            </TwitterShareButton>
            <button aria-label="Copy link to clipboard" className="react-share__ShareButton">
                <CopyToClipboard text={ GAME_HTML[ props.game ] } onCopy={ () => alert('Link copied!') }>
                    <AiOutlineLink/>
                </CopyToClipboard>
            </button>
        </div>
    )
}


SocialShare.defaultProps = {
    game: 'FLAPPY_BLOCK',
    score: null,
    label: 'Share your score',
}

export default SocialShare